import codes from "../config/translate_codes";

function translate_code(key) {
  return codes[key] ?? "-";
}

export default translate_code;
